import axios from 'axios';

const API = axios.create({
  baseURL: '/api'
});

// Add token to requests
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const login = (credentials) => API.post('/auth/login', credentials);
export const getCurrentUser = () => API.get('/auth/me');

// Utilities
export const getUtilities = () => API.get('/utilities');

// Outlets
export const getOutlets = (utilityId) => 
  API.get('/outlets', { params: { utilityId } });
export const getOutlet = (id) => API.get(`/outlets/${id}`);
export const updateOutlet = (id, data) => API.put(`/outlets/${id}`, data);
export const toggleOutletStatus = (id, active) => 
  API.put(`/outlets/${id}/status`, { active });

// Readings
export const createReading = (data) => {
  // Expect { readingValue, outletId, imageUrl, remark }
  return API.post('/readings', {
    readingValue: data.readingValue,
    outletId: data.outletId,
    imageUrl: data.imageUrl || null,
    remark: data.remark || null
  });
};
export const getReadings = (outletId) => 
  API.get('/readings', { params: { outletId } });
export const updateReading = (id, data) => API.put(`/readings/${id}`, data);
export const checkMonthlyReading = (outletId) => 
  API.get(`/readings/check-monthly/${outletId}`);
export const resetReadingImage = (id) => API.put(`/readings/${id}/reset-image`);

// Admin
export const getAllReadings = (filters) => 
  API.get('/admin/readings', { params: filters });
export const exportAdminReadingsCSV = (filters) =>
  API.get('/admin/readings/csv', { params: filters, responseType: 'blob' });
export const getAllOutlets = () => API.get('/admin/outlets');
export const getStatistics = () => API.get('/admin/statistics');
export const createAdminUser = (data) => API.post('/admin/users', data);
export const getAdminUsers = () => API.get('/admin/users');
export const toggleUserStatus = (userId, active) => 
  API.put(`/admin/users/${userId}/status`, { active });

export default API;
